import { render } from "./RichiediAssistenza.vue?vue&type=template&id=bce273a0"
import script from "./RichiediAssistenza.vue?vue&type=script&lang=js"
export * from "./RichiediAssistenza.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__